"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createMultiCurrencyInformationReferenceResolver = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _createSimpleCachedReferenceResolver = _interopRequireDefault(require("../lib/createSimpleCachedReferenceResolver"));

var _CacheKeys = _interopRequireDefault(require("../constants/CacheKeys"));

var _MultiCurrencyApi = require("../api/MultiCurrencyApi");

var createMultiCurrencyInformationReferenceResolver = function createMultiCurrencyInformationReferenceResolver(options) {
  return (0, _createSimpleCachedReferenceResolver.default)((0, _extends2.default)({
    cacheKey: _CacheKeys.default.MULTI_CURRENCY_INFORMATION,
    createFetchData: _MultiCurrencyApi.createFetchMultiCurrencyInfo,
    fetchData: _MultiCurrencyApi.fetchMultiCurrencyInfo
  }, options));
};

exports.createMultiCurrencyInformationReferenceResolver = createMultiCurrencyInformationReferenceResolver;

var _default = createMultiCurrencyInformationReferenceResolver();

exports.default = _default;